import { render, staticRenderFns } from "./LoginBody.vue?vue&type=template&id=373dc8f2&"
import script from "./LoginBody.vue?vue&type=script&lang=js&"
export * from "./LoginBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports